import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid2";


interface IProps {
    detachedPrivate: number | null;
    detachedNonPrivate: number | null;
    detachedTotal: number | null;
    semiDetachedPrivate: number | null;
    semiDetachedNonPrivate: number | null;
    semiDetachedTotal: number | null;
    terracedPrivate: number | null;
    terracedNonPrivate: number | null;
    terracedTotal: number | null;
    bungalowPrivate: number | null;
    bungalowNonPrivate: number | null;
    bungalowTotal: number | null;
    flatHousePrivate: number | null;
    flatHouseNonPrivate: number | null;
    flatHouseTotal: number | null;
    flatBlockPrivate: number | null;
    flatBlockNonPrivate: number | null;
    flatBlockTotal: number | null;
    townhousePrivate: number | null;
    townhouseNonPrivate: number | null;
    townhouseTotal: number | null;
    residentialUnitsOther: string | null;
}

export default function ResidentialUnitsTable(props: IProps) {
    const rows = [
        {
            label: "Detached houses",
            private: props.detachedPrivate ?? 0,
            nonPrivate: props.detachedNonPrivate ?? 0,
            total: props.detachedTotal ?? 0,
        },
        {
            label: "Semi-detached houses",
            private: props.semiDetachedPrivate ?? 0,
            nonPrivate: props.semiDetachedNonPrivate ?? 0,
            total: props.semiDetachedTotal ?? 0,
        },
        {
            label: "Terraced houses",
            private: props.terracedPrivate ?? 0,
            nonPrivate: props.terracedNonPrivate ?? 0,
            total: props.terracedTotal ?? 0,
        },
        {
            label: "Bungalows",
            private: props.bungalowPrivate ?? 0,
            nonPrivate: props.bungalowNonPrivate ?? 0,
            total: props.bungalowTotal ?? 0,
        },
        {
            label: "Flats (in houses)",
            private: props.flatHousePrivate ?? 0,
            nonPrivate: props.flatHouseNonPrivate ?? 0,
            total: props.flatHouseTotal ?? 0,
        },
        {
            label: "Flats (in blocks)",
            private: props.flatBlockPrivate ?? 0,
            nonPrivate: props.flatBlockNonPrivate ?? 0,
            total: props.flatBlockTotal ?? 0,
        },
        {
            label: "Town Houses",
            private: props.townhousePrivate ?? 0,
            nonPrivate: props.townhouseNonPrivate ?? 0,
            total: props.townhouseTotal ?? 0,
        },
    ];

    return (
        <Grid container size={12}>
            <Box>
                <Table size={"small"}>
                    <TableHead>
                        <TableRow>
                            <TableCell />
                            <TableCell><strong>Private</strong></TableCell>
                            <TableCell><strong>Non-Private</strong></TableCell>
                            <TableCell><strong>Total</strong></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.map((row, index) => (
                            <TableRow key={index}>
                                <TableCell>{row.label}</TableCell>
                                <TableCell>{row.private}</TableCell>
                                <TableCell>{row.nonPrivate}</TableCell>
                                <TableCell>{row.total}</TableCell>
                            </TableRow>
                        ))}
                        <TableRow>
                            <TableCell colSpan={4}>
                                <Typography variant="subtitle1" fontWeight="bold">
                                    Other (specify below)
                                </Typography>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={4}>
                                <Typography variant="body2">
                                    {props.residentialUnitsOther ?? ""}
                                </Typography>
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </Box>
        </Grid >
    );
}
